import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { QuoteModuleSettings } from '../../types';

export const fetchQuoteModuleSettings = async () => {
  const response: AxiosResponse<QuoteModuleSettings> = await axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/settings`,
    method: 'get',
  });

  return response.data;
};
